module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.add-to-unscopables.js
 ** module id = 32
 ** module chunks = 2
 **/